import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import generateMiles from "./generateMiles";
import MapSection from "./MapSection";
import { Button, Card, Col, Form, Input, Modal, notification, Row, Select, Switch, Table, Tabs } from "antd";
import Running from "../../../System/Components/Running";
import generatePrices from "./generatePrices";
import dayjs from 'dayjs'
import QuoteTemplate from "./QuoteTemplate";
import { useGlobal } from "../../../System/Global/GlobalProvider";
import { get } from "../../../System/Api/API";
import { unescapeNested } from "../../../System/Global/unescapeArray";

const QuickQuote = () => {

    const location = useLocation();

    const { UserData } = useGlobal();
    const [ form ] = Form.useForm();
    const [ form2 ] = Form.useForm();
    const [ client, setClient ] = useState()
    const [ directions, setDirections ] = useState()
    const [ calculating, setCalculating] = useState(false)
    const [ prices, setPrices ] = useState();
    const [ vehicleTypes, setVehicleTypes ] = useState([])
    const [ clients, setClients ] = useState([])
    const [isRoundTrip, setIsRoundTrip] = useState(false); 
    const [ noClient, setNoClient ] = useState(false);
    const navigate = useNavigate();
    const [ isModalVisible, setIsModalVisible ] = useState();
    const [ currentRecord, setCurrentRecord ] = useState();
    const [ miles, setMiles ] = useState(0)
    
    useEffect( () => {

        ( async () => {

            const _vehicles = await get('vehicle_types', null, [{fieldName: 'maxWeight', orderDirection: 'ASC'}])
            setVehicleTypes(_vehicles)

            console.log('client', client)
        })()
        

    },[])

    useEffect( () => {

        ( async () => {

            const _client = unescapeNested( await get('clients', {clientKey: UserData.clientKey}) )
            console.log(_client)
            setClient(_client[0])
        })()
        

    },[])


    const start = async (_collections, _deliveries, _client) => {

        setCalculating(true)

        try {

            let _mileage = await generateMiles(_collections, _deliveries)

            

            let _prices = await generatePrices(
                _collections, 
                _deliveries, 
                _mileage.miles, 
                isRoundTrip ? 1 : 0,
                _mileage.start, 
                _mileage.end, 
                noClient ? "83d813a0-1b93-11ea-bf0d-4585c4f93cc7x" : _client.clientKey,
                _mileage.startPostcode,
                _mileage.endPostcode

            );



            // setMileage(_mileage)

            if (_mileage.directions) {

                setDirections(_mileage.directions)
                setMiles(_mileage.miles)
            }

            const priceTable = conditionPrices(_prices)

            setPrices(priceTable)

        } catch (err) {

            notification.error({
                message: "Error",
                description: "There was a problem with the collection or delivery information"
            })
            
        }

        setCalculating(false)



        
        

    }

    const conditionPrices = (_prices) => {

        let priceTable = [];
    
        vehicleTypes.forEach((v) => {
            let systemSetRouteRate = _prices.systemSetRouteRates.find(p => p.vtKey === v.vtKey && p.price > 0);
            let clientSetRouteRate = _prices.clientSetRouteRates.find(p => p.vtKey === v.vtKey && p.price > 0);
            let mileageRate = _prices.mileagePrices.find(p => p.vtKey === v.vtKey && p.price > 0);

    
            let lowest = Math.min(
                systemSetRouteRate ? +systemSetRouteRate.price : Number.MAX_VALUE,
                clientSetRouteRate ? +clientSetRouteRate.price : Number.MAX_VALUE,
                mileageRate ? +mileageRate.price : Number.MAX_VALUE
            );
    
            // If no valid prices found, set lowest to a default or null
            if (lowest === Number.MAX_VALUE) {
                lowest = 0; // or null, depending on how you want to handle this case
            }
    
            priceTable.push({
                vtKey:  v.vtKey,
                price: parseFloat(lowest).toFixed(2).toLocaleString(),
                name:   v.name,
                maxWeight: v.maxWeight,
                size: v.size,
                typeCode: v.typeCode,
            });
        });
    
        return priceTable;
    }

    const submitForm = (values) => {

        
            // let collections = values.rawCollections.split(",").map((c) => c.trim())
            // let deliveries = values.rawDeliveries.split(",").map((c) => c.trim())

            let collections = [values.rawCollections]
            let deliveries = [values.rawDeliveries]

            console.log("starting", collections, deliveries, client)
            start(collections, deliveries, client)
        
    }

    const QuoteForm = () => {

        return (
            <Card style={{marginBottom: 30}}>
                <Form onFinish={submitForm} form={form} layout="vertical">
                    <Row gutter={16}>
                        <Col xs={10}>
                            <Form.Item label="&nbsp;" style={{marginBottom: 5}}>
                                <Switch checked={isRoundTrip} style={{marginRight: 20}} checkedChildren="Round Trip" unCheckedChildren="One-way" onChange={(checked) => setIsRoundTrip(checked)} />
                            </Form.Item>
                        </Col>
                    </Row>
                    
                    <Form.Item name="rawCollections" label="Collection" style={{marginBottom: 5}} rules={[
                            {
                                required: true,
                                message: 'Please enter a collection point!',
                            }]}>
                        <Input/>
                    </Form.Item>
                    <Form.Item name="rawDeliveries" label="Delivery" style={{marginBottom: 5}} rules={[
                            {
                                required: true,
                                message: 'Please enter a delivery point!',
                            }]}>
                        <Input/>
                    </Form.Item>
                    <Button style={{width: '100%'}} type="primary" htmlType="submit">Quote</Button>
                </Form>
            </Card>
        )

    }

    const onRowClick = (record) => {
        
        return {
            onClick: async (event) => {

                // setCurrentRecord(record)
                // form2.setFieldsValue({price: record.price})
                // setIsModalVisible(true)                
            },
        };
    };

    

    const handleCancel = () => {
        setIsModalVisible(false);
    };

    const renderForm = () => {

        return (
            <Form for={form2} layout="vertical" initialValues={currentRecord} style={{marginTop: 30}}>
                <Row gutter={16}>
                    <Col span={24}>
                        { noClient &&
                        <Form.Item name="clientName" required>
                            <Input required placeholder="Client name" />
                        </Form.Item> }
                        <Row gutter={16}>
                            <Col span={12}>
                                <Form.Item name="email" required>
                                    <Input required placeholder="Email address" />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item name="price" required>
                                    <Input required placeholder={"price"} type="number" />
                                </Form.Item>
                            </Col>
                            <Col span={24}>
                                <Form.Item name="freeType" required>
                                    <Input required placeholder={"Free type text"} type="text" />
                                </Form.Item>
                            </Col>
                        </Row>
                    </Col>
                    
                    <Col span={24}>
                        <Form.Item>
                            <Button style={{width: '100%', height: 45}} htmlType='submit' type="primary">Send email</Button>
                        </Form.Item>
                    </Col>
                </Row>
                
                
            </Form>
        )
    }

    return (

        calculating ? 
        <Row gutter={16}>
            <Col span={24}>
                <div style={{textAlign: 'center', marginTop: 100}}>
                    <Running/>
                </div>
            </Col> 
        </Row>
        :

        <div style={{padding: 30}}>
        
                <Row gutter={16}>
        
                    <Col span={12}>
                        <QuoteForm/>
                        <MapSection height={450} directions={directions}/> 
                    </Col>
                    <Col xs={12}>
                        
                        <Table 
                            onRow={onRowClick}
                            rowKey={"vtKey"}
                            dataSource={prices}
                            pagination={false}
                            columns={[
                                {
                                    title: 'Vehicle.',
                                    dataIndex: 'name',
                                    key: 'name',
                                },
                                {
                                    title: 'Size.',
                                    dataIndex: 'size',
                                    key: 'size',
                                },
                                {
                                    title: 'Weight.',
                                    dataIndex: 'maxWeight',
                                    key: 'maxWeight',
                                },
                                {
                                    title: 'Price',
                                    render: item => <div style={{textAlign: 'right', paddingRight: 10, fontWeight: 'bold', fontSize: 16}}>£{item.price}</div>,
                                    key: 'price',
                                },
                            ]}
                        />

                    <Modal
                        title="New email"
                        visible={isModalVisible}
                        onCancel={handleCancel}
                        footer={null}
                        width={900}
                    >
                        {renderForm()}
                    </Modal>
                        
                        
                    </Col>
                </Row>
            
                </div>
        
    )

}

export default QuickQuote;
